import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { apiHost } from '../../utils/request';
import { getLocale } from '../../misc';
import history from '../../history';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { StatusBarWrapper, BoxWrapper } from './css';
import SendQuoteToCustomer from './sendQuoteToCustomer';

const WlsStatusBar = ({
  isFormTouched,
  onSaveAndExit,
  onSaveAndContinue,
  onProceedClick,
  onBackClick,
  step,
  isLastStep,
  firstStepOverride,
  shouldHideSubmit,
  orderId,
  hasSendToCustomerOption
}) => {
  const [isEmailModalVisible, setIsEmailModalVisible] = useState(false);
  const localizedStrings = useLocalizedStringsContext();
  const {
    formButtons: {
      continueButtonLabel,
      backLabel,
      saveContinueLaterButtonLabel,
      submitButtonLabel
    }
  } = localizedStrings;

  // Send Email to Customer functionality (not required for the time being)
  // const onSaveAndSendToCustomer = () => {
  //   setIsEmailModalVisible(true);
  // };

  const onQuoteDownload = () => {
    const locale = getLocale();
    const url = `${apiHost}/orders/${orderId}/sevenx-quote-pdf`;
    window.open(url);
    history.push(`/${locale}/wireless/Wireless_Landing_Page?page=1`);
    window.location.reload();
  };

  return (
    <StatusBarWrapper>
      <div id="footer-wrapper">
        <BoxWrapper>
          <>
            {step > (firstStepOverride || 1) && (
              <button
                type="button"
                onClick={onBackClick}
                className="frg-button color-green"
              >
                {backLabel}
              </button>
            )}

            {!isLastStep && (
              <button
                type="button"
                onClick={e => onSaveAndExit(e)}
                style={{ marginLeft: '1em', height: '60px' }}
                className="frg-button color-purple"
                disabled={!isFormTouched}
              >
                {saveContinueLaterButtonLabel}
              </button>
            )}
            {!shouldHideSubmit && (
              <button
                type="button"
                onClick={e => onProceedClick(e)}
                style={{ marginLeft: '1em', height: '60px', marginTop: '1px' }}
                className={`frg-button color-${
                  isLastStep ? 'purple' : 'green'
                }`}
              >
                {isLastStep ? submitButtonLabel : continueButtonLabel}
              </button>
            )}
            {isLastStep && hasSendToCustomerOption && (
              <button
                type="button"
                onClick={onQuoteDownload}
                style={{ marginLeft: '1em', height: '60px', marginTop: '1px' }}
                className={`frg-button color-${
                  isLastStep ? 'purple' : 'green'
                }`}
              >
                Save PDF to send to customer
              </button>
            )}
          </>
        </BoxWrapper>
      </div>
      <SendQuoteToCustomer
        orderId={orderId}
        isModalVisible={isEmailModalVisible}
        setIsModalVisible={() => setIsEmailModalVisible(false)}
      />
    </StatusBarWrapper>
  );
};

WlsStatusBar.propTypes = {
  step: PropTypes.number.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  isFormTouched: PropTypes.bool.isRequired,
  onProceedClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  onSaveAndExit: PropTypes.func.isRequired,
  onSaveAndContinue: PropTypes.func.isRequired,
  firstStepOverride: PropTypes.number,
  shouldHideSubmit: PropTypes.bool.isRequired,
  orderId: PropTypes.number.isRequired,
  hasSendToCustomerOption: PropTypes.bool
};

WlsStatusBar.defaultProps = {
  firstStepOverride: undefined,
  hasSendToCustomerOption: false
};

export default WlsStatusBar;
